export class Button {
  icon?: string;

  text: string;

  hint: string;
}
